<template>
	<div class="second-wraper">
			<el-carousel :interval="5000" indicator-position="none" ref="carousel" :autoplay="false" arrow="never"
					@setActiveItem="setActiveItem" v-if="activeIndex==0" >
			    <el-carousel-item v-for="(item,index) in tab1List" :key="index" >
					<img :src="item.imgSrc" class="imgItem"/>
					<div class="flex-list flex-list1" v-if="index==0" >
						<div class="flex-item" v-for="(item,subIndex) in tab1List[0].subList" :key="subIndex" @click="showModal(subIndex)">
							<img :src="item.smallImgSrc"/>
						</div>
					</div>
					<div class="flex-list flex-list2" v-if="index==1">
						<div class="flex-item" :class="'item'+subIndex" v-for="subIndex in 4" :key="subIndex">
							
						</div>
					</div>
			    </el-carousel-item>
			  </el-carousel>
			  <pagination :list="tab1List" v-if="activeIndex==0" ></pagination>
		
		  <el-carousel :interval="5000" indicator-position="none" ref="carousel" :autoplay="false" arrow="never"
		  		@setActiveItem="setActiveItem" v-if="activeIndex==1" >
		      <el-carousel-item v-for="(item,index) in tab2List" :key="index" >
		  		<img :src="item.imgSrc" class="imgItem"/>
				<div class="flex-list3">
					<el-row type="flex" :gutter="10">
					  <el-col :span="6" v-for="(subItem,subIndex) in item.row1List" :key="subIndex" >
						  <div class="grid-content bg-purple" @click="showModal(subIndex,'row1')"></div>
					  </el-col>
					</el-row>
					<el-row type="flex" justify="end" :gutter="10">
					  <el-col :span="6" v-for="(subItem,subIndex) in item.row2List" :key="subIndex" >
						  <div class="grid-content bg-purple" @click="showModal(subIndex,'row2')"></div>
					  </el-col>
					</el-row>
					<el-row type="flex" justify="end" :gutter="10">
					  <el-col :span="6" v-for="(subItem,subIndex) in item.row3List" :key="subIndex" >
						  <div class="grid-content bg-purple" @click="showModal(subIndex,'row3')"></div>
					  </el-col>
					</el-row>
				</div>
		      </el-carousel-item>
		    </el-carousel>
		    <pagination :list="tab2List" v-if="activeIndex==1 && tab2List.length>2" ></pagination>
			<MaskCom :list="childList" v-if="modalVisible"></MaskCom>
	</div>
  
</template>

<script>
	import Pagination from '../components/Pagination.vue';
	import MaskCom from '../components/MaskCarousel.vue';
	import LeftMenu from '../components/LeftMenu.vue';
	export default {
		name: 'KingstronSecond',
		components: {
			Pagination,MaskCom,LeftMenu
		},
		data() {
			return {
				modalVisible: false,
				activeIndex: 1,
				childList: [], // 弹出框中需要的数据
				tab1List:[{
					imgSrc: require("../../static/Kingstron/swiper-item1-d1.png"),
					subList:[{
						imgSrc:require("../../static/Kingstron/swiper-item1-1.png"),
						smallImgSrc:require("../../static/p4-img1-d1-1.png")
					},{
						imgSrc:require("../../static/Kingstron/swiper-item1-2.png"),
						smallImgSrc:require("../../static/p4-img1-d1-2.png")
					},{
						imgSrc:require("../../static/Kingstron/swiper-item1-3.png"),
						smallImgSrc:require("../../static/p4-img1-d1-3.png")
					},{
						imgSrc:require("../../static/Kingstron/swiper-item1-4.png"),
						smallImgSrc:require("../../static/p4-img1-d1-4.png")
					},{
						imgSrc:require("../../static/Kingstron/swiper-item1-5.png"),
						smallImgSrc:require("../../static/p4-img1-d1-5.png")
					},{
						imgSrc:require("../../static/Kingstron/swiper-item1-6.png"),
						smallImgSrc:require("../../static/p4-img1-d1-6.png")
					},{
						imgSrc:require("../../static/Kingstron/swiper-item1-7.png"),
						smallImgSrc:require("../../static/p4-img1-d1-7.png")
					},{
						imgSrc:require("../../static/Kingstron/swiper-item1-8.png"),
						smallImgSrc:require("../../static/p4-img1-d1-8.png")
					},{
						imgSrc:require("../../static/Kingstron/swiper-item1-9.png"),
						smallImgSrc:require("../../static/p4-img1-d1-9.png")
					}]
				}, {
					imgSrc: require("../../static/Kingstron/swiper-item1-d2.png"),
				}],
				tab2List:[{
					imgSrc: require("../../static/Kingstron/swiper-item2-d.png"),
					row1List:[{
						type: 'img',
						imgSrc:require("../../static/Kingstron/swiper-item2-1.png")
					},
					// {
					// 	type: 'img',
					// 	imgSrc:require("../../static/Kingstron/swiper-item2-2.png")
					// },
					{
						type: 'video',
						videoSrc:'http://cdn.dayuxiaoyu.com/jinshi/61_02.mp4'
					},
					{
						type: 'img',
						imgSrc:require("../../static/Kingstron/swiper-item2-3.png")
					},{
						type: 'img',
						imgSrc:require("../../static/Kingstron/swiper-item2-4.png")
					}],
					row2List:[{
						type: 'img',
						imgSrc:require("../../static/Kingstron/swiper-item2-5.png")
					},{
						type: 'video',
						videoSrc:'http://cdnking.slinqueen.com/jinshi/20230418-1.mp4'
					},{
						type: 'img',
						imgSrc:require("../../static/Kingstron/swiper-item2-7.png")
					}],
					row3List:[{
						type: 'img',
						imgSrc:require("../../static/Kingstron/swiper-item2-8.png")
					},{
						type: 'img',
						imgSrc:require("../../static/Kingstron/swiper-item2-9.png")
					}]
				}],
				
			}
		},
		methods: {
			showModal(subIndex,listIndex) {
				this.modalVisible = true;
				var obj;
				if(listIndex && listIndex=='row1'){
					obj = this.tab2List[0].row1List[subIndex];
				}else if(listIndex && listIndex=='row2'){
					obj = this.tab2List[0].row2List[subIndex];
				}else if(listIndex && listIndex=='row3'){
					obj = this.tab2List[0].row3List[subIndex];
				}else{
					obj = this.tab1List[0].subList[subIndex];
				}
				this.childList[0]= obj;
			},
			hideModal() {
				this.modalVisible = false;
				// this.activeBtn = null;
			},
			backPrevMenu(){ //返回上级目录
				this.$parent.closePage();
			},
			setActiveItem(index) {
			  this.$refs.carousel.setActiveItem(index);
			}
		},
		computed: {
			// animation: function() {
			//   return `flicker 1s infinite`;
			// }
		},
		mounted() {
			var that = this;
			that.activeIndex = that.$route.params.mid ? that.$route.params.mid : '0';
		}
	}
</script>

<style lang="less" scoped>
	@import '../assets/css/index';
	
	.el-carousel  {
	  position:relative;
	  .imgItem{
		  .pos-a(0, 0, 4);
	  }
	  .flex-list1{
		  display: flex;
		  flex-wrap: wrap;
		  .scale(846,967);
		  .pos-a(0, 836, 4);
		  .flex-item{
			  .scale(282,967/3);
			  overflow: hidden;
			  img{
				   transition: 0.3s;
				  &:hover{
					  // animation: scaleAni 1s infinite;
					  transform: scale(1.1);
					  transform-origin: center;
				  }
			  }
		  }
	  }
	  .flex-list2{
	  		  display: flex;
	  		  flex-wrap: wrap;
			  justify-content: space-between;
	  		  .scale(859,522);
	  		  .pos-a(266, 414, 4);
			 
	  		  .flex-item{
	  			  .scale(420,253);
				  margin-bottom:10/@r;
				  background: url('../../static/p4-img1-d2-1.png');
				  background-size:857/@r 522/@r;
				  background-position: 0 0;
			   }
			   .item1{
				   background-position: 0 0;
				   &:hover{
					   background: url('../../static/p4-img1-d2-2.png');
					   background-size:857/@r 522/@r;
				   }
			   }
			   .item2{
				   background-position: -436/@r 0;
				   &:hover{
					   background: url('../../static/p4-img1-d2-2.png');
					   background-size:857/@r 522/@r;
					    background-position: -436/@r 0;
				   }
			   }
			   .item3{
				    background-position: 0 -268/@r;
				   &:hover{
					   background: url('../../static/p4-img1-d2-2.png');
					   background-size:857/@r 522/@r;
					   background-position: 0 -268/@r;
				   }
			   }
			   .item4{
				   background-position: -436/@r -268/@r;
				   &:hover{
					   background: url('../../static/p4-img1-d2-2.png');
					   background-size:857/@r 522/@r;
					   background-position: -436/@r -268/@r;
				   }
			   }
			  
	  }
	  .flex-list3{
		  .scale(1196,891);
		  .pos-a(38, 450, 4);
		  .flex-item{
		  	 .scale(291,288);
		  }
		  .grid-content{
			  .scale(291,288);
		  }
	  }
	}
	 .el-row {
	    margin-bottom: 8/@r;
	    &:last-child {
	      margin-bottom: 0;
	    }
	  }
	  .el-col {
	    border-radius: 4px;
	  }
	 
	  .grid-content {
	    border-radius: 4px;
	    min-height: 36px;
	  }
	
	img {
		display: block;
		width: 100%;
	}

	.content {
		width: 100%;
	}

	.second-wraper {
		// position: relative;
		.scale(1681, 967);
		.pos-a(0, 0, 4);
	}

	.modal-mask {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100
	}
	@keyframes scaleAni {
		// 0%{
		// 	transform: scale(1);
		// }
		100%{
			transform: scale(1.1);
			transform-origin: center;
		}
	}
	
</style>
